import { CONTACT_PAGE_URL, HOME_PAGE_URL } from '../Routes';

export const FooterLinksArray = [
    {
        name: 'Home',
        route: HOME_PAGE_URL
    },
    {
        name: 'Contact',
        route: CONTACT_PAGE_URL
    },
]